import { styled } from "@mui/material/styles";

export const MenuArea = styled("div")(({ theme }) => ({
  borderTop: `1px solid ${theme.custom.colors.mediLightGray}`,
  flexShrink: 0,
  zIndex: 30,
  position: "relative",
  boxShadow: "0px 2px 3px rgb(174 188 197 / 50%)",
}));

export const LinkWrapper = styled("div")(({ theme }) => ({
  textDecoration: "none",
  marginRight: 20,
  marginTop: 10,
  paddingBottom: 10,
  borderBottom: "1px solid white",
  color: theme.custom.colors.mediGray,
  fontWeight: "bold",
  "&:hover, &:focus, &:active": {
    color: theme.custom.colors.mediMagenta,
    borderBottom: `1px solid ${theme.custom.colors.mediMagenta}`,
    cursor: "pointer",
    textDecoration: "none",
  },
  "& a": {
    textDecoration: "none",
    paddingBottom: 12,
  },
}));
